export default __webpack_public_path__ + "static/media/edit-note.9d04644a.svg";